export default __webpack_public_path__ + "static/media/btc.eecdd087.svg";